import React from 'react';
import { Box, Container, Grid, Typography, Link, IconButton, Divider } from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import InstagramIcon from '@mui/icons-material/Instagram';
import { useColorMode } from '../theme/ThemeContext';


const Footer = () => {
  const { mode } = useColorMode();
  return (
    <Box
      sx={{
        bgcolor: 'background.paper',
        pt: 8,
        pb: 4,
        mt: 'auto',
        borderTop: '1px solid rgba(212, 175, 55, 0.1)',
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          {/* Brand */}
          <Grid item xs={12} md={4}>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              <Box
                component="img"
                src={`${process.env.PUBLIC_URL}/${mode === "dark" ? "Darkmode.png" : "images/WhiteMode.png"}`}
                alt="DBShiksha Logo"
                sx={{ height: mode === "dark" ? 60 : 50, width: 'auto' }}
              />
            </Box>
            <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 300, mb: 3 }}>
              Empowering the next generation of AI leaders through industry-standard courses and hands-on learning.
            </Typography>
            <Box sx={{ mt: 1, display: 'flex', gap: 1 }}>
              <IconButton sx={{ color: 'text.primary', '&:hover': { color: '#D4AF37' } }}><FacebookIcon /></IconButton>
              <IconButton sx={{ color: 'text.primary', '&:hover': { color: '#D4AF37' } }}><TwitterIcon /></IconButton>
              <IconButton sx={{ color: 'text.primary', '&:hover': { color: '#D4AF37' } }}><LinkedInIcon /></IconButton>
              <IconButton sx={{ color: 'text.primary', '&:hover': { color: '#D4AF37' } }}><InstagramIcon /></IconButton>
            </Box>
          </Grid>

          {/* Platform */}
          <Grid item xs={6} md={2}>
            <Typography variant="h6" sx={{ color: 'text.primary', mb: 2 }}>Platform</Typography>
            <Link href="/db-shiksha/programs" color="text.secondary" underline="hover" sx={{ display: 'block', mb: 1 }}>Programs</Link>
            <Link href="/db-shiksha/certifications" color="text.secondary" underline="hover" sx={{ display: 'block', mb: 1 }}>Certifications</Link>
            <Link href="/db-shiksha/dashboard" color="text.secondary" underline="hover" sx={{ display: 'block', mb: 1 }}>Login</Link>
          </Grid>

          {/* Support */}
          <Grid item xs={6} md={2}>
            <Typography variant="h6" sx={{ color: 'text.primary', mb: 2 }}>Support</Typography>
            <Link href="/db-shiksha/contact" color="text.secondary" underline="hover" sx={{ display: 'block', mb: 1 }}>Contact Us</Link>
            <Link href="/db-shiksha/faq" color="text.secondary" underline="hover" sx={{ display: 'block', mb: 1 }}>FAQ</Link>
            <Link href="/db-shiksha/privacy" color="text.secondary" underline="hover" sx={{ display: 'block', mb: 1 }}>Privacy Policy</Link>
          </Grid>

          {/* Contact */}
          <Grid item xs={12} md={4}>
            <Typography variant="h6" sx={{ color: 'text.primary', mb: 2 }}>Contact Us</Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>Email: empower@tdtl.world</Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>Phone: +91 92255 84954</Typography>
            <Typography variant="body2" color="text.secondary">Address: Bavdhan, Pune, Maharashtra, India</Typography>
          </Grid>
        </Grid>

        <Divider sx={{ my: 4, borderColor: 'rgba(212, 175, 55, 0.1)' }} />

        <Typography variant="body2" color="text.secondary" align="center">
          © {new Date().getFullYear()} DBShiksha. All rights reserved.
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer;
